// Media type constants
export const MEDIA_TYPE_PDF = "pdf";
export const MEDIA_TYPE_IMAGE = "image";
export const MEDIA_TYPE_VIDEO = "video";
export const MEDIA_TYPE_AUDIO = "audio";

// MIME types
export const ANNOUNCEMENT_DOCUMENT_FILE_EXTENSION = ["application/pdf"];
export const ANNOUNCEMENT_IMAGE_FILE_EXTENSION = ["image/jpeg", "image/png"];
export const ANNOUNCEMENT_VIDEO_FILE_EXTENSION = ["video/mp4"];
export const ANNOUNCEMENT_AUDIO_FILE_EXTENSION = [
  "audio/mpeg",
  "audio/ogg",
  "audio/amr",
];

// Accepted file types for file input
export const ACCEPT_EXTENSIONS = ".pdf,.jpg,.jpeg,.png,.mp4,.mp3,.ogg,.amr";

// Combined MIME types
export const ANNOUNCEMENT_ACCEPT_FILE_EXTENSION = [
  ...ANNOUNCEMENT_DOCUMENT_FILE_EXTENSION,
  ...ANNOUNCEMENT_IMAGE_FILE_EXTENSION,
  ...ANNOUNCEMENT_VIDEO_FILE_EXTENSION,
  ...ANNOUNCEMENT_AUDIO_FILE_EXTENSION,
];

// File size limits (in bytes)
export const ANNOUNCEMENT_ACCEPT_FILE_SIZE = 16 * 1024 * 1024; // 16MB for PDF, video, audio
export const ANNOUNCEMENT_ACCEPT_IMAGE_FILE_SIZE = 5 * 1024 * 1024; // 5MB for images

// Utility function for getting media type from mimetype
export const getMediaType = (mimetype: string): string => {
  if (ANNOUNCEMENT_DOCUMENT_FILE_EXTENSION.includes(mimetype)) {
    return MEDIA_TYPE_PDF;
  }

  if (ANNOUNCEMENT_IMAGE_FILE_EXTENSION.includes(mimetype)) {
    return MEDIA_TYPE_IMAGE;
  }

  if (ANNOUNCEMENT_VIDEO_FILE_EXTENSION.includes(mimetype)) {
    return MEDIA_TYPE_VIDEO;
  }

  if (ANNOUNCEMENT_AUDIO_FILE_EXTENSION.includes(mimetype)) {
    return MEDIA_TYPE_AUDIO;
  }

  return "";
};
